import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; 
import { useTranslation } from 'react-i18next';
import { fetchAreas, fetchGroups, getCachedGroups } from '../Core/FetchData';
import SelectionThumbnail from '../Utilites/SelectionThumbnail';
import SelectionList from '../Utilites/SelectionList';

import '../Core/i18n';

const GroupSelection = ({ onChange, lang }) => {
    const navigate = useNavigate(); 
    const { t } = useTranslation();
    const { t: selectionT } = useTranslation('selection');
    const [groups, setGroups] = useState(() => getCachedGroups(lang) || []);
    const [loading, setLoading] = useState(() => getCachedGroups(lang) === null);

    const prepareGroup = (group) => { void fetchAreas(lang, group).catch(() => {}); };

    const changeGroup = (group) => {
        prepareGroup(group);
        onChange(group); 
        navigate('/quiz/select-area');
    };

    useEffect(() => {
        if (!lang?.code) {
            navigate('/quiz');
        }
    }, [lang, navigate]);

    // Načtení dostupných oblastí z API
    useEffect(() => {
        let active = true;
        const cached = getCachedGroups(lang);
        setLoading(cached === null);
        setGroups(cached || []);
        const loadGroups = async () => {
            const fetchedGroups = await fetchGroups(lang); 
            if (active) {
                setGroups(fetchedGroups);
                setLoading(false);
            }
        };
        loadGroups();
        return () => { active = false; };
    }, [lang]);

    return (
        <div id="quiz-groupSelection"> 

            <SelectionList items={groups} loading={loading} loadingLabel={selectionT('loading')}>
                {groups.length > 0 ? (
                    groups.map((group) => {
                        return (
                        <li key={`group-${group.id}`} data-search={group.name.toLowerCase()} className="group group-unlocked">
                            <button 
                                onPointerDown={() => prepareGroup(group)}
                                onClick={() => changeGroup(group)}
                                title={group.name}
                                className="btn-primary"
                                style={{ transitionDuration: '0.4s' }} 
                            > 
                                {group.image && (
                                    <div className="placeholder">
                                        <SelectionThumbnail image={group.image} alt={group.name} />
                                    </div>
                                )}
                                <strong className="text-shadow">
                                    {group.name} 
                                </strong>
                                <span className="hidden text-[0.85rem] leading-[1.3rem] pt-1 opacity-100">
                                    {group.wordsCount} {t('words')}
                                </span>
                            </button>
                        </li>
                        );
                    })
                ) : (
                    <li role="status">{loading ? selectionT('loading') : t('no-groups-found')}</li>
                )}
            </SelectionList>
        </div>
    );
};

export default GroupSelection;
